(function () {

  'use strict';

  /**
   * @author Chester Rivas/Zain Syed
   * @ngdoc directive
   * @name uteBody
   * @description
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .directive('uteBody', ["$rootScope", "uteLocale", "uteCoreFactory", "util", "env", "$timeout", "$state", function ($rootScope, uteLocale, uteCoreFactory, util, env, $timeout, $state) {

      return {
        restrict: 'EA',
        scope: false,
        controller: ["$scope", "$element", function ($scope, $element) {

          /**
           * @description add language
           */
          var language = uteLocale.language;

          /**
           * @description add province
           */
          var province = uteLocale.province;

          /**
           * @description add env name
           */
          var envName = env.name;

          $element.attr('ute-language', language);
          $('html').attr('ute-language', language); // need language on body and html tags
          $element.attr('ute-province', province);
          $element.attr('ute-env', envName);
          $element.attr('ute-province-services', $rootScope.ruiMethods.getProvinceServices());
          $element.attr('ute-user-services', $rootScope.ruiMethods.user.services());

          $element.attr('body-classes', '');

          $rootScope.$watch('userInfo', function (nv) {

            if (!_.isEmpty(nv) && !_.isUndefined(nv)) {

              if (angular.isDefined(nv.uuid)) {
                $element.attr('ute-login-state', nv ? 'post' : 'pre');
              }

              if (angular.isDefined(nv.cfaInfo) && !_.isEmpty(nv.cfaInfo)) {
                var user = $rootScope.ruiMethods.user.is.agent() ? ('agent ' + $rootScope.ruiMethods.agent.type()) : 'cx';
                console.log('ute-user:', user);
                $element.attr('ute-user', user);
              }

            }

          }, true);

          $rootScope.$watch('stateName', function (nv) {
            if (!_.isEmpty(nv) && !_.isUndefined(nv)) {
              $element.attr('ute-page', nv);
            }
          });

          $rootScope.$watch('currentState', function (nv) {
            if (!_.isEmpty(nv) && _.has(nv, 'data.functionality')) {
              $element.attr('func', nv.data.functionality);
            } else {
              $element.attr('func', '');
            }
          }, true);

          /**
           * @description catch click events; if the user is an agent, renew their session
           */
          $($element[0]).on('click', function () {
            if ($rootScope.ruiMethods.user.is.agent()) {
              $timeout(function () {
                util.renewAgentSession();
              }, 0);
            }
          });

          // if isPhone is true then close mobile nav
          if ($.restive.isPhone()) {
            $($element[0]).find('#ute-page')
              .on('click', function () {
                $rootScope.mobileNavOpen = false;
              });
          }

          /**
           * @description when the timer stops; kill cfa session and redirect back to ssp portal
           */
          $scope.$on('timer-stopped', function () {
            // if the agent is active, end their session
            if ($rootScope.ruiMethods.user.is.agent()) {
              $timeout(function () {
                util.endAgentSession();
              }, 0);
            }
          });

          /**
           * scroll window to top on state change; only if the parents for each state are different
           * 'app' state is the exception
           */
          $scope.$on('$stateChangeSuccess', function (evt, toState, toParams, fromState) {
            if (fromState.parent !== toState.parent || fromState.parent === 'app' && toState.parent === 'app') {
              $($element[0]).animate({ scrollTop: 0 }, 0);
            }
          });

        }]
      };

    }]);

})();
